/** Letter-by-letter spelling in a speech transcript ("W-O-L-T dot C-O dot I-L", "F E E D") assembled into the string the
 *  user meant. STT renders a spelled word as letters, and the reflex otherwise keeps the sound-alike word it heard. */
const GROUP = String.raw`(?:\b[A-Za-z](?:-[A-Za-z]){1,}\b|\b[A-Z](?: [A-Z]){2,}\b)`;
const SEP = String.raw`\s*(?:\b[Dd]ot\b|\b[Pp]eriod\b|\.)\s*`;
const RUN = new RegExp(`${GROUP}(?:${SEP}${GROUP})*`, 'g');

export function spelledOut(text: string): string[] {
  const out: string[] = [];
  for (const m of text.matchAll(RUN)) {
    const raw = m[0];
    if (!/^[A-Za-z][- ]/.test(raw)) continue; // a group must be single letters
    const parts = raw.split(new RegExp(SEP)).map((g) => g.replace(/[- ]/g, ''));
    const word = parts.join('.');
    if (word.replace(/\./g, '').length < 3) continue;
    const s = parts.length > 1 ? word.toLowerCase() : word;
    if (!out.includes(s)) out.push(s);
  }
  return out;
}

/** The note appended to a user turn that spells something out (empty when nothing is spelled). */
export function spellingNote(text: string): string {
  const w = spelledOut(text);
  return w.length ? `\n[spelled out letter by letter: ${w.map((x) => `"${x}"`).join(', ')} — that spelling is exact and replaces the word you heard]` : '';
}
